import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-no-chats',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './no-chats.component.html',
})
export class NoChatsComponent {

}
